'use client'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { AccountService } from '@/services/account.service'
import { Label } from '@radix-ui/react-label'
import Cookies from 'js-cookie'
import { Suspense, useEffect, useState } from 'react'
import { toast } from 'sonner'

export default function ResetPassword({ searchParams }: any) {
	const [password, setPassword] = useState('')
	const [confirmPassword, setConfirmPassword] = useState('')
	const [email, setEmail] = useState('')

	// Логин кладёт в куку шаг восстановления. Читаем в эффекте, а не в рендере,
	// чтобы не разошлась гидрация: на сервере куки js-cookie не видит.
	useEffect(() => {
		setEmail(Cookies.get('email') || '')
	}, [])

	const productId: string | null = searchParams.product_id

	function onSubmit(e: React.FormEvent<HTMLFormElement>): void {
		e.preventDefault()

		if (password !== confirmPassword) {
			toast.error('Пароли не одинаковы! повторите попытку')
			setConfirmPassword('')
			return
		}
		if (confirmPassword === password) {
			AccountService.newPassword(password)
				.then(response => {
					if (response) {
						toast.success('Вход выполнен успешно!')
						setTimeout(() => {
							if (productId) {
								window.location.href = `/profile/subscriptions/subscribe?product_id=${productId}`
								;('3')
							} else {
								window.location.href = '/profile'
							}
						}, 1000)
					}
				})
				.catch(error => {
					toast.error(error.response?.data?.message || 'Ошибка запроса')
				})
		}
	}

	return (
		<Suspense>
			<div className='flex min-h-screen w-full items-center sm:justify-center justify-start flex-col px-4 py-6 sm:px-6 lg:px-8'>
				<form
					className='space-y-6 w-full max-w-md mx-auto p-6 rounded-lg shadow-lg bg-white/5 backdrop-blur-sm border border-gray-800'
					onSubmit={onSubmit}
				>
					{/* Скрытое поле с логином: без него iCloud Keychain не может
					    привязать новый пароль к аккаунту и не предлагает его
					    сохранить. sr-only, а не hidden — элемент должен остаться
					    в раскладке, иначе менеджеры паролей его игнорируют. */}
					{email && (
						<input
							type='text'
							name='username'
							autoComplete='username'
							value={email}
							readOnly
							tabIndex={-1}
							aria-hidden='true'
							className='sr-only'
						/>
					)}
					<div className='space-y-4'>
						<div className='space-y-2'>
							<Label
								htmlFor='new-password'
								className='text-sm font-medium text-gray-200'
							>
								Пароль
							</Label>
							<Input
								id='new-password'
								name='new-password'
								type='password'
								autoComplete='new-password'
								placeholder='••••••••'
								className='w-full bg-gray-900/50 border-gray-800 focus:border-blue-500 focus:ring-blue-500 text-white'
								value={password}
								onChange={e => setPassword(e.target.value)}
								required
							/>
						</div>
						<div className='space-y-2'>
							<Label
								htmlFor='confirm-new-password'
								className='text-sm font-medium text-gray-200'
							>
								Подтвердите пароль
							</Label>
							<Input
								id='confirm-new-password'
								name='confirm-new-password'
								type='password'
								autoComplete='new-password'
								placeholder='••••••••'
								className='w-full bg-gray-900/50 border-gray-800 focus:border-blue-500 focus:ring-blue-500 text-white'
								value={confirmPassword}
								onChange={e => setConfirmPassword(e.target.value)}
								required
							/>
						</div>
					</div>
					<Button
						type='submit'
						className='w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-medium py-2 px-4 rounded-md transition-all duration-200 ease-in-out transform hover:scale-[1.02] active:scale-[0.98]'
					>
						Подтвердить
					</Button>
				</form>
			</div>
		</Suspense>
	)
}
